import React, { useState, useEffect } from 'react';
import { setSelectedPaymentData } from '../../../../../redux/checkoutredux/actions/checkoutactions/checkoutActions'; 
import PayLabel from '../../../../assets/svg/PayLabel';
import UpdateCheckoutAction from '../../../Actions/UpdateCheckoutAction.ts'; 
import CreditCardForm from './CreditCardForm';

const BlockPayment = ({store}) => {
  const [selectedPayment, setSelectedPayment] = useState(null);
  //const paymentmethods = store.getState().paymentmethods;
  const paymentmethods = store.getState().checkoutcontext.checkoutcontextall.checkoutcontextinitial?.paymentmethods;
  const paymenhtmlmethods = store.getState().checkoutcontext.checkoutcontextall.checkoutcontextinitial?.paymenthtml;
  console.log("THE PAYMENTMETHODS HERE: ",paymentmethods);
  console.log("THE PAYMENTMETHODS HERE HTML: ",paymenhtmlmethods);
  const [accordionState, setAccordionState] = useState({});

  console.log("Pre init updateCheckoutActionInstance NEW");
  const updateCheckoutActionInstance = new UpdateCheckoutAction();

  useEffect(() => {
console.log("Pre init updateCheckoutActionInstance");
    updateCheckoutActionInstance.load();

    
  }, []); // Leeres Abhängigkeitsarray bedeutet, dass es nur einmal beim Laden der Komponente aufgerufen wird.



  useEffect(() => {
    const initialState = {};

    console.log("Pre init updateCheckoutActionInstance 2");
    updateCheckoutActionInstance.load();

    //const payindex = selectedPayment ? paymentmethods.paymentmethod.findIndex(payment => payment.id === selectedPayment.id) : -1;
    const payindex = selectedPayment ? paymentmethods.findIndex(payment => payment.id === selectedPayment.id) : -1;

   /* paymentmethods.paymentmethod.forEach((_, index) => {
      initialState[`accordion${index + 1}Checked`] = index === (payindex !== -1 ? payindex : 0);
    });*/

    paymentmethods.forEach((_, index) => {
      initialState[`accordion${index + 1}Checked`] = index === (payindex !== -1 ? payindex : 0);
    });

    setAccordionState(initialState);
  }, [paymentmethods, selectedPayment]);

  const handleAccordionChange = (index) => {
    const newAccordionState = {};

    Object.keys(accordionState).forEach((key) => {
      newAccordionState[key] = key === `accordion${index + 1}Checked`;
    });

    setAccordionState({ ...newAccordionState, [`accordion${index + 1}Checked`]: true });
    //setSelectedPayment(paymentmethods.paymentmethod[index]);
    setSelectedPayment(paymentmethods[index]);
    //store.dispatch(setSelectedPaymentData(paymentmethods.paymentmethod[index]));
    store.dispatch(setSelectedPaymentData(paymentmethods[index]));
  };

  const handleCheckboxChange = (index) => {
    setAccordionState({ ...accordionState, [`accordion${index + 1}Checked`]: true });
    //setSelectedPayment(paymentmethods.paymentmethod[index]);
    setSelectedPayment(paymentmethods[index]);
  };

  return (
    <div id="ips-payment-checkout-details" className="ips-module">
      <div className="row g-3">
        <h4 className="mb-3">Zahlung</h4>
        <div className="accordion" id="accordionPayment">
          {//paymentmethods.paymentmethod.map((payment, index) => (
            paymentmethods.map((payment, index) => (
            <div className="accordion-item ips-checkout-item-color" key={index}>
              <h2 className="accordion-header ips-checkout-header-color" id={`panelsStayOpen-heading${index + 1}`}>
                <button
                  className={`accordion-button ips-${index === 0 ? 'first' : 'second'}element ${accordionState[`accordion${index + 1}Checked`] ? '' : 'collapsed'}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#panelsStayOpen-collapse${index + 1}`}
                  aria-expanded={accordionState[`accordion${index + 1}Checked`]}
                  aria-controls={`panelsStayOpen-collapse${index + 1}`}
                  onClick={() => handleAccordionChange(index)}
                >
                  <div className="form-check mt-1">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="accordionOptionPayment"
                      id={`accordionOptionPayment${index + 1}`}
                      checked={accordionState[`accordion${index + 1}Checked`]}
                      onChange={() => handleCheckboxChange(index)} 
                      readOnly
                    />
                  </div>
                 
                  <div style={{ color: 'black', paddingLeft: '15px' }}>{payment.title}</div>
                  <div style={{ marginLeft: 'auto', paddingLeft: '15px', paddingRight: '15px' }}><PayLabel paytype={payment.id} payicon={payment.icon} /></div>
                </button>
              </h2>
              <div
                id={`panelsStayOpen-collapse${index + 1}`}
                className={`accordion-collapse collapse ${accordionState[`accordion${index + 1}Checked`] ? 'show' : ''}`}
                aria-labelledby={`panelsStayOpen-heading${index + 1}`}
                data-bs-parent="#accordionPayment"
              >
                <div className="accordion-body ips-checkout-body-color m-3" style={{ backgroundColor: '#e7e7e7' }}>
                {payment.description}
                  {payment.id === 'mollie_wc_gateway_creditcard' && <CreditCardForm store={store}/>}
                </div>
              </div>
            </div>
          ))}
        </div>

{/* Hier wird der HTML-Inhalt von paymenhtmlmethods hinzugefügt */}
<div id="ips-payment-checkout-details" className="ips-module" dangerouslySetInnerHTML={{ __html: paymenhtmlmethods }} />

        
      </div>
    </div>
  );
};

export default BlockPayment;